import { useTranslations } from 'next-intl'

import { PreferencesSectionHeader } from '../preferences-section-header'

import AccountSecurity from './account-security'
import AccountTheme from './account-theme'

const AccountTab = () => {
  const t = useTranslations('UserPreferences.accounts')
  return (
    <div className="flex h-full flex-col">
      <PreferencesSectionHeader title={t('title')} description={t('description')} />
      <div className="flex flex-1 flex-col overflow-y-auto overflow-x-hidden">
        <AccountTheme />
        <AccountSecurity />
      </div>
    </div>
  )
}

export default AccountTab
